var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MPButton',{attrs:{"color":_vm.color,"size":_vm.size,"disabled":_vm.disabled,"data-spec":_vm.dataSpec},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"btn-description"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }